module.exports = __webpack_public_path__ + "img/demo-takeout-600x450.5226cf13.jpg";